import React, { useState, useEffect } from 'react';
import { Box, Alert } from '@mui/material';
import { level1API } from '../services/api';
import Level1Header from '../components/Level1Header';
import MarketHealthCards from '../components/MarketHealthCards';
import BreadthTrendChart from '../components/BreadthTrendChart';
import SectorAnalysisTable from '../components/SectorAnalysisTable';
import Level1DashboardSkeleton from '../components/level1/Level1DashboardSkeleton';

function Level1Dashboard() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [level1Data, setLevel1Data] = useState([]);
  const [breadthData, setBreadthData] = useState([]);
  const [breadthDays, setBreadthDays] = useState(30);
  const [calculating, setCalculating] = useState(false);

  const fetchData = async (days = breadthDays) => {
    try {
      setLoading(true);
      setError(null);
      const [latest, breadth] = await Promise.all([
        level1API.getLatest(),
        level1API.getBreadth(days),
      ]);
      setLevel1Data(latest.data);
      setBreadthData(breadth.data);
    } catch (err) {
      console.error('Error fetching Level 1 data:', err);
      setError(err.response?.data?.detail || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleDaysChange = async (days) => {
    setBreadthDays(days);
    try {
      const breadth = await level1API.getBreadth(days);
      setBreadthData(breadth.data);
    } catch (err) {
      console.error('Error fetching breadth trend for timeframe:', err);
    }
  };

  const handleCalculate = async () => {
    try {
      setCalculating(true);
      setError(null);
      await level1API.calculate();
      await fetchData();
    } catch (err) {
      console.error('Error calculating market breadth:', err);
      setError(err.response?.data?.detail || 'Calculation failed');
    } finally {
      setCalculating(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  if (loading) return <Level1DashboardSkeleton />;
  if (error) return <Box sx={{ p: 3 }}><Alert severity="error">{error}</Alert></Box>;

  const latestBreadth = breadthData[0] || {};
  const marketHealth = latestBreadth.market_health || 'N/A';
  const tradeDate = latestBreadth.trade_date || level1Data[0]?.trade_date;

  return (
    <Box sx={{ width: '100%', px: 0, py: { xs: 1, sm: 2 } }}>
      <Level1Header onRefresh={() => fetchData()} tradeDate={tradeDate} onCalculate={handleCalculate} calculating={calculating} />
      <MarketHealthCards marketHealth={marketHealth} latestBreadth={latestBreadth} />
      <BreadthTrendChart breadthData={breadthData} selectedDays={breadthDays} onDaysChange={handleDaysChange} />
      <SectorAnalysisTable sectorData={level1Data} />
    </Box>
  );
}

export default Level1Dashboard;
